export default "__VITE_ASSET__CgPzfc_M__"